import { Button, TextField, Typography } from "@mui/material";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import { useAuth } from "oidc-react";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { filterAllowedColumn, ShowError, ShowSucess } from "../../_helper/helper";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
import visileColumns from "./visibleColumns";

const StatusData = [{ label: 'Urgent', value: 'Urgent' }, { label: 'Non-Urgent', value: 'Non-Urgent' }, { label: 'FYI', value: 'FYI' }, { label: 'Notification', value: 'Notification' }, { label: 'Past Due', value: 'Past Due' }]

const BenefitNotification = () => {
  let {
    columns,
    loadingSearch,
    searchParameter,
    ColumnsSorted,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const userData = useAuth()
  const [notificationText, setNotificationText] = useState("")
  const [notifiactionStatus, setNotificationStatus] = useState("Notification")
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [sortedColumns, setSortedColumns] = useState([]);
  const [searchParams, setSearchParams] = useState([]);
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([{ field: "CreatedDate", dir: "desc" }]);
  const [pageSize, setPageSize] = useState(10);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [DeparementCode, setDepartmentCode] = useState(userData?.profile?.DEPT_CODE ? userData.profile.DEPT_CODE[0] : '')
  const history = useNavigate();
  const listName = "Benefits_Notifications";


  const SendNotificatiob = () => {

    getWhere()
    const payload = {
      employeeId: 0,
      notificationText: notificationText,
      remark: 'Benefits',
      status: notifiactionStatus,
      application: "Benefits"
    }
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/Notification/CreateNotification`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      )
      .then((response) => {
        setSortData([{ field: "CreatedDate", dir: "desc " }])
        ShowSucess("Successfully Created.");
        setNotificationText("")
        setNotificationStatus("")
      })
      .catch((error) => {
        ShowError("Internal Server Error !");
      });
  }

  useEffect(() => {

    //  let searchParam= []
    // 	if (DeparementCode) {
    // 		searchParam.push({
    // 			columnName: "DeptCode",
    // 			operator: "=",
    // 			value: DeparementCode,
    // 			dataType: "varchar(max)",
    // 			logicOperator: "AND",
    // 		});
    // 	}else{
    // 		searchParam = searchParams.filter((i) => i.columnName !== "DeptCode" )
    // 	}
    if (DeparementCode) {
      setAdditionalWhere(`Department = '${DeparementCode}'`)
    }

    // setSearchParams(searchParam);

  }, [DeparementCode])



  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  useEffect(() => {
    if (ColumnsSorted[listName] !== undefined) {
      setSortedColumns(ColumnsSorted[listName]);
    } else {
      if (columns && visileColumns.length > 0 && columns.length > 0) {
        const clms = visileColumns.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(
          filterAllowedColumn(userData, visileColumns.concat(data)),
          "employeeID"
        );
      }
    }
  }, [columns]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  const getWhere = () => {
    // if (userData.profile.role === "user") {
    //   return `employeeID = ${userData?.profile?.EmployeeID}  ${additionalWhere ? `and ${additionalWhere}` : ``
    //     }`;
    // } else {
    return additionalWhere;
    // }
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row className="bg-primary rounded m-0 p-0 py-3 mb-3 ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">
              {/* <div> */}
              {/* <Icon style={{ fontSize: '25px', margin:"10px"}} name="file-ascx" /> */}
              <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
              Benefits Notifications
              {/* </div> */}
            </Typography>
          </div>
        </Row>
        <Card style={{ marginTop: "10px", padding: "10px" }}>
          <Row className="mb-2">
            {/* <Col md="6" >
              <FormControl sx={{ minWidth: 220 }} size="small">
                <InputLabel id="demo-select-small-label">
                  Notification Status
                </InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={notifiactionStatus}

                  label="Notification Status"

                  onChange={(e) => {
                    setNotificationStatus(e.target.value);
                  }}
                >
                  {StatusData?.map((i) => {
                    return <MenuItem value={i.value}>{i.label}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Col> */}
          </Row>
          <Row className="mb-3">
            <Col className="mb-3">
              <TextField
                fullWidth
                size="small"
                autoComplete="off"
                inputProps={{
                  maxLength: 200,

                }}
                margin="dense"
                variant="outlined"
                label={"Notification Text"}
                multiline
                rows={3}
                value={notificationText}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setNotificationText(e.target.value);
                }}
              />

            </Col>
          </Row>
          <Col>
            <Button
              variant="contained"
              className="bg-primary"
              onClick={SendNotificatiob}
            >
              Save
            </Button>
          </Col>

        </Card>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <AdvanceSearch
                  id={listName}
                  gridId={listName}
                  location="Benefits-global"
                  columnList={"*"}
                  columnRefernces={[]}
                  tableName={"vw_benefit_notification"}
                  searchParams={searchParams}
                  additionalWhere={getWhere()}
                  expanded={true}
                  sortData={sortData}
                  pageNumber={page}
                  pageSize={pageSize}
                  chooseFilterMethod={chooseFilterMethod}
                  applicationName={'Benefits'}
                />

                <div>
                  {sortedColumns.length > 0 && (
                    <TelerikDataTable
                      id={listName}
                      pageSize={pageSize}
                      totalCount={rowCount}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      data={results || []}
                      sortData={sortData}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      // actions={actions}
                      isDashboard={true}
                      setChooseFilterMethod={setChooseFilterMethod}
                      chooseFilterMethod={chooseFilterMethod}
                    ></TelerikDataTable>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>
    </Fragment>
  );
};

export default BenefitNotification;
